<div class="modal-header">
  <c-button
    type="ghost"
    size="small"
    [iconOnly]="true"
    [icon]="backIcon"
    [ariaLabel]="'common.back' | transloco"
    (action)="back()" />
  <h1 class="modal-header__title">{{ title }}</h1>
</div>
